import React from "react";
import styled from "@emotion/styled";

type TabsProps = {
  tabs: string[];
  setTab: (tab: string) => void;
  tab: string;
};

export default function Tabs({ tabs, setTab, tab }: TabsProps) {
  console.log("TABS", tabs, "TAB", tab);

  return (
    <div style={{display: "flex", gap: 15}}>
      {tabs.map((buttonTab) => (
        <TabButton
          key={buttonTab}
          className={`tab ${buttonTab === tab ? "active" : ""}`}
          onClick={() => setTab(buttonTab)}
        >
          {buttonTab}
        </TabButton>
      ))}
    </div>
  );
}

const TabButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  border-bottom: 1px solid #fff;
  color: #707070;
  font-family: Gotham-Medium;
  text-transform: capitalize;
  &.active {
    border-bottom: 1px solid #33CCFF;
    color: #707070;
  }
`;
